import { createAction } from '@reduxjs/toolkit';

import { PinLifecycleState } from 'app/store/root-types';

export const setCurrentPinState = createAction<PinLifecycleState>('SET_CURRENT_PIN_STATE');
export const pinChanged = createAction<string>('PIN_CHANGED');
